import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import * as wActs from "../actions/website-actions";
import { FormattedMessage } from "react-intl";
import SeoHeaders from "../components/SeoHeaders";
import {Link} from "react-router-dom";

class Signup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      regSelect: "block",
      regForm: "none"
    };
  }



  handleClick(evt, tType) {
    evt.preventDefault();
    this.props.dispatch({ type: wConsts.SIGNUP_SET_TYPE, payload: tType });
    this.setState({
      regSelect: "none",
      regForm: "block"
    });
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleCloseAlert() {
    this.setState({ showingAlert: false });
  }
  handleCloseSuccess() {
    this.setState({ showingSuccess: false });
  }

  handleSubmit(evt) {
    const data = {
      "UserName": this.formUsername.value,
      "Password": this.formPassword.value,
      "EmailAddress": this.formEmail.value,
      "Type": this.props.WebPage.SignUp.Type,
      "Source": "escortnews"
    };
    this.props.dispatch(wActs.Signup(data,this.props.history, wActs.getCultPath(this.props.WebPage,"/confirm")));
  }

  PopupCenter(url, title, w, h) {
    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }

    return newWindow;
  }


  handleENewsClick(evt) {
    evt.preventDefault();
    $.fancybox.close();
    this.PopupCenter("https://oauth.escortnews.eu/auth/login", "loginWindow", 410, 515);
    window.addEventListener("message", function (event) {
      if (event.origin.toLowerCase().indexOf("oauth") > 0) {
        if (event.data.token_type === "Bearer") {
          let domain = "." + wActs.getSubdomain(window.location.hostname);
          wActs.setCookie("auth", event.data.access_token, { path: "/", maxAge: 31557600, domain: domain });
          window.location = "/";
        }
      } else {
        console.log("Bad Origin", event);
      }
    }, false);
  }



  render() {

    return (

      <div className="main-content left">
        <SeoHeaders Position={"Top"}/>
        <div id="register-select" style={{background: "#fff", display: this.state.regSelect, padding: "5px"}}>
          <div className="regular-content">
            <div className="centered-content" style={{paddingTop: "20px"}}><h3>{this.getTranslation("page.signup.howdoyouwanttosignup")}</h3></div>
            <div className="row account-type" style={{marginLeft: "10px", marginRight: "10px"}}>
              <div className="col_33">
                <div className="type"><a href=" #" title="" onClick={(e) => { this.handleClick(e, "member"); }} className=""><img src="/imgs/member-bg.jpg" alt="Member" /></a></div>
                <a href=" #" title="" onClick={(e) => { this.handleClick(e, "member"); }} className="button" style={{ width: "100%", maxWidth: "100%", minWidth: "100%" }}>{this.getTranslation("page.signup.member")}</a>
              </div>
              <div className="col_33">
                <div className="type"><a href=" #" title="" onClick={(e) => { this.handleClick(e, "independentmodel"); }} className=""><img src="/imgs/model-bg.jpg" alt="Model" /></a></div>
                <a href=" #" title="" onClick={(e) => { this.handleClick(e, "independentmodel"); }} className="button" style={{ width: "100%", maxWidth: "100%", minWidth: "100%" }}>{this.getTranslation("page.signup.independentmodel")}</a>
              </div>
              <div className="col_33">
                <div className="type"><a href=" #" title="" onClick={(e) => { this.handleClick(e, "agent"); }} className=""><img src="/imgs/agency-bg.jpg" alt="Agency" /></a></div>
                <a href=" #" title="" onClick={(e) => { this.handleClick(e, "agent"); }} className="button" style={{ width: "100%", maxWidth: "100%", minWidth: "100%" }}>{this.getTranslation("page.signup.agencycompany")}</a>
              </div>
              <div className="col_100">
                  <p style={{minHeight: "40px",fontSize: "1.5rem", marginTop: "10px", textAlign: "center"}}><br/><br/><i><FormattedMessage id={"page.signup.alreadyhaveaccount"}>{(...content) => content}</FormattedMessage>&nbsp;&nbsp;&nbsp;<Link to={wActs.getCultPath(this.props.WebPage,"/login")} title=""><FormattedMessage id={"page.signup.loginhere"}>{(...content) => content}</FormattedMessage></Link></i></p>
                  <p className="centered-content" style={{minHeight: "auto"}}>&nbsp;</p>
                  <a href=" #" onClick={(e) => this.handleENewsClick(e)} title="" className="button small full orange small-mb"><FormattedMessage id={"page.login.loginwithyourescortnewsaccount"}>{(...content) => content}</FormattedMessage></a>

              </div>
            </div>
          </div>
          <div style={{width: "90%", height: "400px"}}>&nbsp;</div>
        </div>
        <div id="register-form">
          <div id="register-popup" className="popup-wrapper" style={{background: "#fff", display: this.state.regForm }}>
            <div className="popup-content" style={{ width: "100%", padding: "30px 20px 40px 20px", background: "#fff"}}>

              <p><i><FormattedMessage id={"page.signup.alreadyhaveaccount"}>{(...content) => content}</FormattedMessage> <Link to={wActs.getCultPath(this.props.WebPage,"/login")} title=""><FormattedMessage id={"page.signup.loginhere"}>{(...content) => content}</FormattedMessage></Link></i></p>
              <div className="input-block">
                <label><FormattedMessage id={"page.email"}>{(...content) => content}</FormattedMessage></label>
                <input ref={(ref) => { this.formEmail = ref; }} type="email" name="" placeholder="example@gmail.com" />
              </div>

              <div className="input-block">
                <label><FormattedMessage id={"page.login.username"}>{(...content) => content}</FormattedMessage></label>
                <input ref={(ref) => { this.formUsername = ref; }} type="text" name="" placeholder={this.getTranslation("page.login.username")} />
              </div>

              <div className="input-block">
                <label><FormattedMessage id={"page.login.password"}>{(...content) => content}</FormattedMessage></label>
                <input ref={(ref) => { this.formPassword = ref; }} type="password" name="" placeholder="" />
              </div>

              <div className="input-block">
                <label><FormattedMessage id={"page.signup.confirmpassword"}>{(...content) => content}</FormattedMessage></label>
                <input ref={(ref) => { this.formPasswordC = ref; }} type="password" name="" placeholder="" />
              </div>
              {this.props.WebPage.SignUp.Status !== wConsts.SIGNUP_STATUS_PENDING &&
                <button type="button" onClick={(evt) => { this.handleSubmit(evt); }} className="button full" name="" ><FormattedMessage id={"page.submit"}>{(...content) => content}</FormattedMessage></button>
              }
              {this.props.WebPage.SignUp.Status === wConsts.SIGNUP_STATUS_PENDING &&
                <img src={"/imgs/loader.gif"} width={"75"} height={"75"} alt={"loading..."} style={{ margin: "auto", contentAlign: "center", justifyContent: "center", display: "flex" }} />
              }

              <p className="centered-content" style={{minHeight: "100px"}}>&nbsp;</p>
              <a href=" #" onClick={(e) => this.handleENewsClick(e)} title="" className="button small full orange small-mb"><FormattedMessage id={"page.login.loginwithyourescortnewsaccount"}>{(...content) => content}</FormattedMessage></a>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
  };
};

export default connect(mapStateToProps)(Signup);
